/* tslint:disable */

/**
 */
export class VehicleActivityView {
    name?: string;
}
